import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4570a552"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "cloneModuleModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "cloneModuleModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Clone Module", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Target Project")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select a project", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Target Process")
], -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select a process", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Target Sub Process (optional)")
], -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  selected: "",
  value: ""
}
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "mt-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Target Miletsone")
], -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select a milestone", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(" Clone this module: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.module.title), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _hoisted_10,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProjectId) = $event))
              }, [
                _hoisted_11,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                  return (_openBlock(), _createElementBlock("option", {
                    selected: "",
                    value: project.projectId,
                    key: project.projectId
                  }, _toDisplayString(project.name), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedProjectId]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedProcessId) = $event)),
                disabled: !_ctx.selectedProjectId
              }, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process) => {
                  return (_openBlock(), _createElementBlock("option", {
                    selected: "",
                    value: process.typeId,
                    key: process.typeId
                  }, _toDisplayString(process.name), 9, _hoisted_17))
                }), 128))
              ], 8, _hoisted_15), [
                [_vModelSelect, _ctx.selectedProcessId]
              ])
            ]),
            (_ctx.subprocesses.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSubProcessId) = $event)),
                    disabled: !_ctx.selectedProjectId
                  }, [
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.selectedSubProcessId ? 'Deselect the' : 'Select a') + " sub process", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subprocesses, (subprocess) => {
                      return (_openBlock(), _createElementBlock("option", {
                        selected: "",
                        value: subprocess.processId,
                        key: subprocess.processId
                      }, _toDisplayString(subprocess.name), 9, _hoisted_22))
                    }), 128))
                  ], 8, _hoisted_20), [
                    [_vModelSelect, _ctx.selectedSubProcessId]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedStepId) = $event)),
                disabled: !_ctx.selectedProcessId
              }, [
                _hoisted_26,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.milestones, (milestone) => {
                  return (_openBlock(), _createElementBlock("option", {
                    selected: "",
                    value: milestone.stepId,
                    key: milestone.stepId
                  }, _toDisplayString(milestone.name), 9, _hoisted_27))
                }), 128))
              ], 8, _hoisted_25), [
                [_vModelSelect, _ctx.selectedStepId]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success ms-2",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            disabled: _ctx.submitted || !_ctx.isSelected
          }, _toDisplayString(_ctx.submitted ? "Cloning" : "Clone"), 9, _hoisted_29)
        ])
      ])
    ])
  ]))
}